import React from "react";
import styles from "./academic-nonacademic-stat-card.module.css";
import CustomTag from "../../common/custom-tag/custom-tag";
import SVGIcon from "../../constants/SVGIcon";
import { PieChart, Pie, Cell } from "recharts";
import { cardColorArr } from "../../constants/common";

const AcademicNonacademicStatCard = ({
  level,
  total_students,
  total_male,
  total_female,
  total_teachers,
  chart_label_1,
  chart_label_2,
  chart_color_1,
  chart_color_2,
  is_academic,
  total_medals,
  is_teachers,
  teacher,
}) => {
  const data = [
    { name: chart_label_1, value: Number(total_male) },
    { name: chart_label_2, value: Number(total_female) },
  ];

  const COLORS = [chart_color_1, chart_color_2];

  const randomIndex = Math.floor(Math.random() * cardColorArr.length);

  const getColorIndexFromLevel = (level) => {
    let hash = 0;
    for (let i = 0; i < level.length; i++) {
      hash = level.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(hash) % cardColorArr.length;
  };

  const index = getColorIndexFromLevel(level);

  const colorStyle = cardColorArr[index];

  return (
    <div
      className={styles.academic_nonacademic_stat_card}
      style={{
        background: cardColorArr[randomIndex]?.background,
        border: `1px solid ${cardColorArr[randomIndex]?.border}`,
      }}
    >
      <div className={styles.academic_nonacademic_stat_card_top}>
        <div
          className={
            is_teachers && is_academic
              ? styles.teacher_academic_stat_card_top_left
              : is_teachers && !is_academic
              ? styles.teacher_nonacademic_stat_card_top_left
              : styles.academic_nonacademic_stat_card_top_left
          }
        >
          {is_teachers &&
            (is_academic ? (
              <CustomTag
                text={level}
                color={colorStyle?.color}
                background={colorStyle?.background}
                borderColor={colorStyle?.border}
              />
            ) : (
              <>
                <h3>{level}</h3>
                <CustomTag
                  text={teacher}
                  color={colorStyle?.color}
                  background={colorStyle?.background}
                  borderColor={colorStyle?.border}
                />
              </>
            ))}
          {!is_teachers && (
            <>
              <CustomTag
                text={level}
                color={colorStyle?.color}
                background={colorStyle?.background}
                borderColor={colorStyle?.border}
              />
              <p
                className={
                  styles.academic_nonacademic_stat_card_top_left_teachers
                }
              >
                <SVGIcon
                  name={is_academic ? "person-icon" : "badge-icon"}
                  width={is_academic ? "15" : "20"}
                  height={is_academic ? "15" : "20"}
                  className="anticon"
                  stroke={"rgba(136, 136, 136, 1)"}
                />
                {is_academic ? (
                  <span>Teachers: {total_teachers}</span>
                ) : (
                  <span>Medals: {total_medals}</span>
                )}
              </p>
            </>
          )}
        </div>
        <div className={styles.academic_nonacademic_stat_card_top_right}>
          <PieChart width={52} height={52}>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={25}
              innerRadius={23}
              dataKey="value"
              stroke="none"
              fill="none"
              isAnimationActive={false}
              paddingAngle={12}
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill="none"
                  stroke={COLORS[index]}
                  strokeWidth={2}
                  strokeLinejoin="round"
                />
              ))}
            </Pie>
          </PieChart>
          <div className={styles.total_container}>
            <span>{total_students}</span>
            <span>Total</span>
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        <p className={styles.bottom_males}>
          <span className={styles.males_marker}></span>
          <span className={styles.total_gender}>Male:&nbsp;{total_male}</span>
        </p>
        <p className={styles.bottom_females}>
          <span className={styles.females_marker}></span>
          <span className={styles.total_gender}>
            Female:&nbsp;{total_female}
          </span>
        </p>
      </div>
    </div>
  );
};
export default AcademicNonacademicStatCard;
